export default "__VITE_ASSET__2NnkpUKO__"